export const menuItems = [
    {
        id: 0,
        label: "menu.data.title",
        isTitle: true
    },
    {
        id: 1,
        label: "menu.applications.title",
        icon: "fad fa-laptop-code",
        link: "/applications",
        requiresSubscription: false,
    },
    {
        id: 4,
        label: "menu.enterprise-api.title",
        icon: "fad fa-brackets-curly",
        link: "/enterprise-api",
        requiresEPR: true,
    },
    {
        id: 2,
        label: "menu.documentation.title",
        icon: "fad fa-book",
        link: "/documentation/data-api",
    },
    {
        id: 3,
        label: "menu.hephaistos.title",
        icon: "fad fa-sensor-smoke",
        link: "/documentation/hephaistos",
    },
    {
        id: 10,
        label: "menu.gamelabs.title",
        isTitle: true
    },
    {
        id: 11,
        label: "menu.documentation.gamelabs.dayz",
        icon: "fad fa-book",
        link: "/documentation/gamelabs/dayz",
        requiresSubscription: false,
    },
	{
		id: 12,
		label: "menu.gamelabs.workshop.title",
		icon: "fab fa-steam",
		link: "/gamelabs/workshop",
	}
	/*
	{
        id: 5,
        label: "menu.etc.title",
        isTitle: true
    },
    {
        id: 6,
        label: "menu.assets.title",
        icon: "fad fa-box-full",
        link: "/etc/assets",
    },
    {
        id: 4,
        label: "menu.documentation.geo_api",
        icon: "fad fa-network-wired",
        link: "/documentation/public-api/geo",
        requiresSubscription: false,
    },
    {
        id: 4,
        label: "menu.documentation.convert_api",
        icon: "fad fa-fingerprint",
        link: "/documentation/public-api/convert",
        requiresSubscription: false,
    },
	*/
];

